import React from "react"
import Arrow from "../../assets/arrow.svg";

const CircleButton = (
  {
    title = "",
    direction = "left",
    desktopTextSide = 'right',
    onClick = () => {},
  }) => {
  return (
    <button
      type="button"
      className={`circle-button circle-button--text-desktop-${desktopTextSide}`}
      aria-label={title || "Button"}
      onClick={onClick}
    >
      <span className="circle-button__scroll-button-icon-wrapper">
        <Arrow className={`circle-button__scroll-button-icon circle-button__scroll-button-icon--${direction}`} />
      </span>
      {title && (
        <span className="circle-button__scroll-button-text">{title}</span>
      )}
    </button>
  )
}

export default CircleButton
